import "core-js/modules/es.array.concat.js";
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "chat-module"
};
import { ref } from 'vue';
import IframeContainer from './IframeContainer.vue';
import { getStore } from '@/util/store';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var _ref = getStore({
        name: 'accessInfo'
      }) || {},
      access_token = _ref.access_token;
    //
    var url = "".concat(window.location.origin, "/sub-objectives-mandate-svc/?token=").concat(access_token, "&pageType=studentPad");
    var visible = ref(false);
    var newUrl = ref('');
    var fileName = ref('');
    var handlePreviewFile = function handlePreviewFile(val) {
      console.log('文件预览', val);
      newUrl.value = val.data;
      fileName.value = val.fileName;
      visible.value = true;
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(IframeContainer, {
        src: url,
        onPreviewFile: handlePreviewFile
      })]);
    };
  }
};